import {observer} from 'mobx-react-lite'
import {useLocation} from 'react-router-dom'
import {useEffect} from 'react'
import clubStore from '../../../storage/ClubStore'
import PageLayout from '../../PageLayout'
import appStore from '../../../storage/AppStore'
import Select from '../../../ui/Select'
import './parent.css'
import GamesFilter from "../../Games/GamesFilter";
import NumericPagination from "../../NumericPagination";
import GamesList from "../../Games/GamesList";

const Games = () => {
  const location = useLocation();
  const contest = clubStore.parent.contest
  useEffect(() => {
    if (clubStore.parent.children.length === 0) {
        clubStore.parent.getChildren().then(() => {
          contest.searchGames()
        })
    }
    if (clubStore.parent.child_id) {
      contest.searchGames()
    }
  }, [location.pathname])
  
  return (
    <PageLayout header={
      <div className="flex justify-content-between align-items-center">
        <h3 className="m-0">{appStore.tr.games}</h3>
      </div>
    } filters={
      <>
        <div className="page-filters">
            <Select store={clubStore.parent} prop="child_id"
                    options={clubStore.parent.children}
                    optionLabel={"title"}
                    optionValue={"id"}
                    id={"input_child"}
                    label={appStore.tr.child}
                    onChange={(val) => {
                        contest.gamesQuery.setProperty('company_user_id', clubStore.parent.child_id)
                        contest.searchGames()
                    }}
            />
          </div>
        <GamesFilter store={contest}/>
      </>
    } pagination={
                  <NumericPagination
                    query={contest.gamesQuery}
                    onPageChange={(page) => {
                      contest.gamesQuery.setProperty("page_number", page);
                      contest.searchGames();
                    }}
                  />
                }>
      <GamesList role={'PRNT'} games={contest.games} detailsBasePath={'/parent/game'}/>
    </PageLayout>
  )
}
export default observer(Games)